import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const CTASection = () => {
  const { t } = useTranslation();
  const { direction } = useLanguage();
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate('/login');
  };

  return (
    <section id="cta" className="py-20 bg-synagogue-light">
      <div className="container mx-auto px-4 md:px-6">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 text-center">
          <div className="max-w-3xl mx-auto">
            <h2 className={`text-3xl md:text-4xl font-bold mb-4 text-synagogue-blue ${direction === 'rtl' ? 'text-right md:text-center' : 'text-left md:text-center'}`}>
              {t('ctaTitle')}
            </h2>
            <p className={`text-lg md:text-xl mb-8 text-gray-600 ${direction === 'rtl' ? 'text-right md:text-center' : 'text-left md:text-center'}`}>
              {t('ctaSubtitle')}
            </p>
            <div className="flex justify-center">
              <Button
                onClick={handleSignUp}
                className="bg-synagogue-gold hover:bg-synagogue-blue text-white font-bold py-3 px-8 rounded-lg text-lg transition-colors shadow-md"
              >
                {t('ctaButton')}
              </Button>
            </div>
          </div>

          {/* Decorative elements */}
          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="flex flex-col items-center text-synagogue-blue">
              <div className="text-4xl font-bold">100+</div>
              <div className="text-sm text-gray-600">{direction === 'rtl' ? 'קהילות' : 'Communities'}</div>
            </div>
            <div className="flex flex-col items-center text-synagogue-blue">
              <div className="text-4xl font-bold">1000+</div>
              <div className="text-sm text-gray-600">{direction === 'rtl' ? 'מתפללים' : 'Congregants'}</div>
            </div>
            <div className="flex flex-col items-center text-synagogue-blue">
              <div className="text-4xl font-bold">24/7</div>
              <div className="text-sm text-gray-600">{direction === 'rtl' ? 'תמיכה' : 'Support'}</div>
            </div>
            <div className="flex flex-col items-center text-synagogue-blue">
              <div className="text-4xl font-bold">99.9%</div>
              <div className="text-sm text-gray-600">{direction === 'rtl' ? 'זמן פעילות' : 'Uptime'}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection; 